export default "__VITE_PUBLIC_ASSET__a21de2fa__"